<mat-card appearance="outlined">
  <mat-card-content>

    <ngx-mat-facet-toolkit
      [facets]="facets"
      [config]="config"
      [identifier]="identifier"
      (facetChange)="output.filterUpdated($event)"
      [chipLabelsEnabled]="settings.chipLabelsEnabled"
      [confirmOnRemove]="settings.confirmOnRemove"
      [clearButtonEnabled]="settings.clearButtonEnabled"
      placeholder="Add a filter..."
      clearButtonText="CLEAR FILTERS">
    </ngx-mat-facet-toolkit>

  </mat-card-content>
</mat-card>

<mat-divider></mat-divider>

<div class="content">

  <app-settings
    #settings
    (facetsUpdated)="facetsUpdated($event)"
    [currentIdentifier]="identifier"
    [strategy]="strategy"
    (strategyUpdated)="strategyUpdated($event)"
    (manualIdentifierUpdated)="manualIdentifierUpdated($event)">
  </app-settings>
  <mat-divider [vertical]="true"></mat-divider>
  <app-output #output></app-output>

</div>
